import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { HourFormat12Pipe } from '@df/ui/display/hour-format-12.pipe';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { LocalStore } from '../store.decorator';
@Component({
    selector: 'store-open-status',
    templateUrl: './store-open-status.html',
    styleUrls: ['./store-open-status.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [CommonModule, TranslationModule, HourFormat12Pipe]
})
export class StoreOpenStatusComponent {
    @Input()
    store?: LocalStore;
    get isOpenNow(): boolean {
        return !!this.store?.isOpenToday && !!this.store?.isOpenNow;
    }
    get nextOpenStatus(): string | undefined {
        if (this.store) {
            const open = this.store.nextOpenDay?.open;
            if (open) {
                if (this.store.isNextOpenDayToday) {
                    return this.store.nextOpenDay?.open;
                } else if (this.store.nextOpenDayName) {
                    return [this.store.nextOpenDayName, open].join(' ');
                }
            }
        }
        return '';
    }
}
